﻿package com.mgacreative.hotelru.feature.channelmanager.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.feature.channelmanager.domain.ChannelManagerService
import com.mgacreative.hotelru.feature.channelmanager.domain.OtaReservation
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class ChannelRule(val channelName: String, val markupPercentage: Double, val isSyncActive: Boolean)

class ChannelManagerViewModel(
    val service: ChannelManagerService
) : ViewModel() {

    private val _rules = MutableStateFlow<List<ChannelRule>>(emptyList())
    val rules: StateFlow<List<ChannelRule>> = _rules.asStateFlow()

    init {
        _rules.value = listOf(
            ChannelRule("Booking.com", 15.0, true),
            ChannelRule("Expedia", 12.5, true),
            ChannelRule("Airbnb", 3.0, false)
        )
    }

    fun testIncomingOtaBooking(roomId: String, date: String) {
        viewModelScope.launch {
            val res = OtaReservation(
                id = "ota_${kotlin.random.Random.nextInt()}",
                channel = "Booking.com",
                roomId = roomId,
                guestName = "Jane Doe",
                checkIn = date,
                checkOut = "2026-07-25"
            )
            service.receiveOtaReservation(res)
        }
    }

    fun updateMarkup(channel: String, newMarkup: Double) {
        _rules.value = _rules.value.map {
            if (it.channelName == channel) it.copy(markupPercentage = newMarkup) else it
        }
    }
}

